/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FinancialsSummary } from './FinancialsSummary';
import {
    FinancialsSummaryFromJSON,
    FinancialsSummaryFromJSONTyped,
    FinancialsSummaryToJSON,
    FinancialsSummaryToJSONTyped,
} from './FinancialsSummary';

/**
 * Tournament financial summary
 * @export
 * @interface FinancialsResponse
 */
export interface FinancialsResponse {
    /**
     * 
     * @type {FinancialsSummary}
     * @memberof FinancialsResponse
     */
    financials: FinancialsSummary;
}

/**
 * Check if a given object implements the FinancialsResponse interface.
 */
export function instanceOfFinancialsResponse(value: object): value is FinancialsResponse {
    if (!('financials' in value) || value['financials'] === undefined) return false;
    return true;
}

export function FinancialsResponseFromJSON(json: any): FinancialsResponse {
    return FinancialsResponseFromJSONTyped(json, false);
}

export function FinancialsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancialsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'financials': FinancialsSummaryFromJSON(json['financials']),
    };
}

export function FinancialsResponseToJSON(json: any): FinancialsResponse {
    return FinancialsResponseToJSONTyped(json, false);
}

export function FinancialsResponseToJSONTyped(value?: FinancialsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'financials': FinancialsSummaryToJSON(value['financials']),
    };
}

